/**
 * Element.closest( selector ) polyfill
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#polyfill
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#polyfill
 */
(function(){
    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }
    if (!Element.prototype.closest) {
        Element.prototype.closest = function(s) {
            var el = this;
            do {
                if (el.matches(s)) return el;
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }
})();

/**
 * find and fix buttons with old markup and classes
 */
(function(){
    var elems = document.querySelectorAll('.site-btn .icon-download');
    if (!elems.length) return;
    elems.forEach(function(elem){
        elem.parentElement.classList.add('site-btn--o2');
        elem.parentElement.classList.add('site-btn--icon-download');
        elem.remove();
    });
})();

// check for pardot iframes and do auto-resize
if (iframeResize) iframeResize({
    license: 'GPLv3',
    waitForLoad: true,
}, '.pardot-iframe');
